export type ShoppingCartMessageType = 'send-message' | 'make-a-change';
// Enum for cart item types
export enum CartItemType {
  QUOTE_REQUEST = 'quote-request',
  RIDER = 'rider'
}

// Base interface for all shopping cart items
export interface ShoppingCartItemBase {
  id: string;
  quantity: number;
  display_name: string; // e.g. "Bond"
  price: number; // e.g. 100
  tax: number; // e.g. 10
  shipping: number; // e.g. 5
  showQuantity: boolean;

  getTotal(): number;
  getTax(): number;
  getShipping(): number;
  getSubtotal(): number;
  getTotalWithTax(): number;
  getTotalWithShipping(): number;
  getTotalWithTaxAndShipping(): number;
}

// Specific item types with discriminated union
export interface QuoteRequestCartItem<T = any> extends ShoppingCartItemBase {
  type: CartItemType.QUOTE_REQUEST;
  data: T;
}

export interface RiderCartItem<T = any> extends ShoppingCartItemBase {
  type: CartItemType.RIDER;
  data: T;
}

// Union type for all possible cart items
export type ShoppingCartItem<T = any> =
  | QuoteRequestCartItem<T>
  | RiderCartItem<T>;

// Type guards for runtime type checking
export function isQuoteRequestItem(item: ShoppingCartItem): item is QuoteRequestCartItem {
  return item.type === CartItemType.QUOTE_REQUEST;
}

export function isRiderItem(item: ShoppingCartItem): item is RiderCartItem {
  return item.type === CartItemType.RIDER;
}
